import React, {useEffect, useState} from 'react'
import DataTable from "react-data-table-component";
import axios from "axios";
import Option from "../../components/Form/Option";
import imgSinhala from './img/pharmacy_sinhala.jpg'
import imgTamil from './img/pharmacy_tamil.jpg'
import imgEnglish from './img/pharmacy_english.jpg'

const PharmaciesTable = (props) => {
  const [pharmaciesState, setPharmaciesState] = useState();
  const [pharmaciesRequestState, setPharmaciesRequestState] = useState();

  const [columnsState, setColumnsState] = useState([
    {
      name: 'District',
      selector: 'district',
      sortable: true,
    }, {
      name: 'Local Area',
      selector: 'council',
      sortable: true,
    }, {
      name: 'Address',
      selector: 'address',
      sortable: true,
    }, {
      name: 'Name',
      selector: 'name',
      sortable: true,
    }, {
      name: 'Phone',
      selector: 'phone',
      sortable: true,
    }, {
      name: 'WhatsApp',
      selector: 'whatsApp',
      sortable: true,
      format: row => {
        if ("" !== row.whatsApp) {
          return (
            <i className="fa fa-whatsapp">&nbsp;
              <a href={"https://api.whatsapp.com/send?phone=" + row.whatsApp}>{row.whatsApp}</a>
            </i>
          );
        }
      }
    }, {
      name: 'Viber',
      selector: 'Viber',
      sortable: true,
      format: row => {
        if ("" !== row.Viber) {
          return (
            <i className="fa fa-phone">&nbsp;
              <a href={"viber://add?number=" + row.Viber}>{row.Viber}</a>
            </i>
          );
        }
      }
    }
  ]);

  useEffect(() => {
    axios.get('/assets/data/sets.json')
      .then(response => {

        let pharmacies = response.data;
        pharmacies.map((pharmacy, index) => {
          // pharmacy.whatsApp = "<a href=\"https://api.whatsapp.com/send?phone=94772660787\" " +
          //   " data-original-title=\"Click to order through WhatsApp\">Order " + pharmacy.whatsApp + "</a>";
          // pharmacy.whatsApp = "whatsapp://" + pharmacy.whatsApp;
          pharmacy[index] = pharmacy;
        });

        setPharmaciesState(pharmacies);
        setPharmaciesRequestState(pharmacies);
      })
      .catch(error => {

      });
  }, []);

  const districts = [
    'Colombo',
    'Ampara',
    'Anuradhapura',
    'Badulla',
    'Batticaloa',
    'Galle',
    'Gampaha',
    'Hambantota',
    'Jaffna',
    'Kalutara',
    'Kandy',
    'Kegalle',
    'Kilinochchi',
    'Kurunegala',
    'Mannar',
    'Matale',
    'Matara',
    'Monaragala',
    'Mullaitivu',
    'Nuwara',
    'Polonnaruwa',
    'Puttalam',
    'Ratnapura',
    'Trincomalee',
    'Vavuniya',
  ];

  const paginationOptions = {paginationTotalRows: 50, paginationPerPage: 100};

  const handleDistrictChange = (event) => {
    const district = event.target.value;

    console.log(district);

    const currentState = pharmaciesRequestState.filter(state => {
      return state.district === district;
    });

    setPharmaciesState(currentState);
  };

  const districtOptions = districts.map(district => {
    return <Option value={district}/>
  });

  return (
    <section>
      <div className="section-body">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <select onChange={handleDistrictChange}>
                  {districtOptions}
                </select>
                {/*<FormControlLabel*/}
                {/*label="Dark Mode"*/}
                {/*control={(*/}
                {/*<Switch*/}
                {/*checked={theme === 'dark'}*/}
                {/*onChange={handleChange}*/}
                {/*/>*/}
                {/*)}*/}
                {/*/>*/}
                <DataTable
                  title="Select district to find a pharmacy"
                  columns={columnsState}
                  data={pharmaciesState}
                  // theme={theme}
                  striped
                  highlightOnHover
                  noDataComponent={'Please wait till we locate pharmacies...'}
                  // selectableRows
                  // selectableRowsComponent={Checkbox}
                  // selectableRowsComponentProps={{inkDisabled: true}}
                  // progressComponent={<LinearIndeterminate/>}
                  // sortIcon={<FontIcon>arrow_downward</FontIcon>}
                  // onSelectedRowsChange={handleChange}
                  pagination
                  paginationComponentOptions={paginationOptions}
                  // paginationComponent={<CustomMaterialPagination rowCount={100} currentPage={1} />}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-4">
            <div className="card">
              <img src={imgEnglish} alt="Pharmacy ordering instructions" width="100%"/>
            </div>
          </div>
          <div className="col-sm-4">
            <div className="card">
              <img src={imgSinhala} alt="Pharmacy ordering instructions" width="100%"/>
            </div>
          </div>
          <div className="col-sm-4">
            <div className="card">
              <img src={imgTamil} alt="Pharmacy ordering instructions" width="100%"/>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PharmaciesTable;
